import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export default function UnsuccessfulShorteningSharingLink() {
    const modalTitle = <Typography>Teilen nicht erfolgreich!</Typography>;
    const modalContent = (
        <ContentTypography>Der Beitrag wurde nicht geteilt.</ContentTypography>
    );

    return { modalTitle, modalContent, autoClosingModal: true };
}
